<template>
  <transition name="fade">
    <div class="popup" ref="popup" v-if="show">
      <div class="content">
        <div class="top">
          <button class="close" @click="close">
            <img src="@/assets/images/icons/close.svg" alt="">
          </button>
        </div>
        <div class="text">
          {{ info }}
        </div>
        <div class="bottom">
          <button class="cancel" @click="close">
            {{ cancelButton }}
          </button>
          <button @click="$emit('confirm', id)">
            {{ confirmButton }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "deleteDialog",
  props: {
    text: {
      type: String,
      default: 'Уверены?'
    },
    cancelButton: {
      type: String,
      default: 'Отменить'
    },
    confirmButton: {
      type: String,
      default: 'Удалить'
    },

  },
  data: () => ({
    show: false,
    id: null,
    info: null
  }),
  mounted() {
    this.info =  this.text;
  },
  methods: {
    open(id = null, text = null) {
      this.info = text || this.info;
      if (id == null) return console.info('delDiag: id parameter is null');
      this.show = true;
      this.id = id;
      this.$emit('showed');
    },
    close() {
      this.show = false;
      this.id = null
    }
  }
}
</script>

<style scoped lang="scss">
.popup {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2.5px);
  background-color: rgba(0, 0, 0, 0.1);

  .content {
    overflow: hidden;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    text-align: center;
    border-radius: 10px;
    background-color: #fff;
    width: 400px;
    height: 200px;
    display: flex;
    flex-direction: column;

    & .top {
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .close {
        width: 22px;
        height: 22px;
        background-color: transparent;
        border: none;

        img {
          width: 100%;
        }
      }
    }

    & .text {
      justify-self: center;
      padding: 0 40px;
      font-size: 20px;
      line-height: 28px;
      color: #383838;
    }

    & .bottom {
      border-top: solid 2px #e5e5e5;
      margin-top: auto;
      width: 100%;

      & button {
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        text-align: center;
        width: 50%;
        background: transparent;
        border: none;
        height: 48px;
        font-size: 16px;
        line-height: 24px;
        color: #383838;
        border-left: solid 1px #e5e5e5;

        &:hover {
          background-color: rgba(255, 0, 0, 0.1);
        }

        &.cancel {
          color: #808080;
          border-right: solid 1px #e5e5e5;

          &:hover {
            background-color: rgba(0, 0, 0, 0.1);
            color: #383838;
          }
        }
      }
    }
  }
}

@media (max-width: 380px) {
  .content {
    margin: 0 15px;
  }
}
</style>
